import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ModalUnsavedConfirmation from '../../components/ModalUnsavedConfirmation'
import LoadingWrapper from '../../components/LoadingWrapper'
import Toast from '../../components/Toast'
import { Button, Grid } from 'semantic-ui-react'
import UserForm from '../../components/Users/UserForm'
import UsersStore from '../../stores/UsersStore'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'

@withRouter
@observer
class UsersCreateScreen extends Component {
  static propTypes = {
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.usersStore = new UsersStore()
    this.usersStore.newUser()
    window.document.title = 'Créer un utilisateur'
  }

  componentDidMount () {
    this.usersStore.loadDeps()
  }

  componentWillUnmount () {
    this.usersStore = null
  }

  handleSaveUser = () => {
    this.usersStore.save().then((result) => {
      if (result.success) {
        this.props.history.push('/users')
      }
    })
  }

  render () {
    const { isLoading, isSaving, toasts, roles, equipments, isDirty } = this.usersStore

    return (
      <>
        <ModalUnsavedConfirmation
          when={isDirty}
          onSave={this.handleSaveUser}
        />
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Toast toasts={toasts} />
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column>
              <UserForm
                usersStore={this.usersStore}
                roles={roles} equipments={equipments}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Column>
            <Button
              content='Enregistrer'
              primary
              onClick={this.handleSaveUser}
            />
          </Grid.Column>
        </Grid>
      </>
    )
  }
}

export default UsersCreateScreen
